import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  FormGroup,
  ReactiveFormsModule,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DateModule } from '../../../date.module';
import { MatInputModule } from '@angular/material/input';
import dayjs from 'dayjs';
import { PaymentTermEditDialogComponent } from '../../payment/payment-term-edit-dialog/payment-term-edit-dialog.component';
import { CurrencyTypeEnum, PaymentTypeEnum } from '@pulpo/pulpo-models';
import {
  PaymentConditionPipe,
  PaymentCurrencyTypePipe,
  PaymentEventTypePipe,
} from '../../../pipes';

@Component({
  selector: 'add-special-sale-dialog',
  templateUrl: './add-special-sale-dialog.component.html',
  styleUrls: ['./add-special-sale-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    DateModule,
    MatInputModule,
    PaymentEventTypePipe,
    PaymentConditionPipe,
    PaymentCurrencyTypePipe,
  ],
})
export class AddSpecialSaleDialogComponent implements OnInit {
  editForm: FormGroup;
  PaymentTypeEnum = PaymentTypeEnum;
  CurrencyTypeEnum = CurrencyTypeEnum;

  constructor(
    private dialogRef: MatDialogRef<AddSpecialSaleDialogComponent>,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.editForm = this.formBuilder.group({
      customerMail: [null, [Validators.required]],
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      dateSent: [dayjs(), [Validators.required]],
      paymentTerm: [null],
    });
  }

  openPaymentTermDialog() {
    const dialogRef = this.dialog.open(PaymentTermEditDialogComponent, {
      data: {},
      width: '75%',
      panelClass: 'pulpo-dialog-container',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result != -1) {
        this.editForm.get('paymentTerm')?.setValue(result);
        this.cdr.markForCheck();
      }
    });
  }

  get paymentTerm() {
    return this.editForm.get('paymentTerm')?.value;
  }

  save() {
    this.dialogRef.close(this.editForm.value);
  }
}
